import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/sahajink-logo.png";

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      <footer className="bg-[#060e1c] border-t border-white/10 pt-20">
        {/* Top Footer */}
        <div className="max-w-[1200px] mx-auto px-6 grid md:grid-cols-[1.5fr_2fr] gap-14 sm:gap-20 pb-14">
          {/* Brand */}
          <div>
            <Link
              to="/"
              onClick={handleLinkClick}
              className="flex items-center gap-2 mb-[20px] text-white"
            >
              <img className="w-[200px] h-auto" src={logo} alt="logo" />
            </Link>

            <p className="text-gray-400 text-sm leading-relaxed max-w-[300px]">
              Premium custom label printing solutions for businesses of all
              sizes. Quality you can trust, delivery you can count on.
            </p>
          </div>

          {/* Links */}
          <div className="grid sm:grid-cols-3 gap-10">
            {/* Quick Links */}
            <div className="flex flex-col gap-3">
              <h5 className="font-bold text-white text-sm tracking-wider uppercase mb-1">
                Quick Links
              </h5>

              <Link
                to="/#about"
                className="text-gray-400 text-sm hover:text-blue-400"
              >
                About Us
              </Link>
              <Link
                to="/#products"
                className="text-gray-400 text-sm hover:text-blue-400"
              >
                Products
              </Link>
              <Link
                to="/#industries"
                className="text-gray-400 text-sm hover:text-blue-400"
              >
                Industries
              </Link>
              <Link
                to="/#process"
                className="text-gray-400 text-sm hover:text-blue-400"
              >
                Our Process
              </Link>
            </div>

            {/* Products */}
            <div className="flex flex-col gap-3">
              <h5 className="font-bold text-white text-sm tracking-wider uppercase mb-1">
                Products
              </h5>

              <Link
                to="/#products"
                className="text-gray-400 text-sm hover:text-blue-400"
              >
                Product Labels
              </Link>
              <Link
                to="/#products"
                className="text-gray-400 text-sm hover:text-blue-400"
              >
                Barcode Labels
              </Link>
              <Link
                to="/#products"
                className="text-gray-400 text-sm hover:text-blue-400"
              >
                Pharma Labels
              </Link>
              <Link
                to="/#products"
                className="text-gray-400 text-sm hover:text-blue-400"
              >
                Food Labels
              </Link>
              <Link
                to="/#products"
                className="text-gray-400 text-sm hover:text-blue-400"
              >
                Cosmetic Labels
              </Link>
            </div>

            {/* Contact */}
            <div className="flex flex-col gap-3">
              <h5 className="font-bold text-white text-sm tracking-wider uppercase mb-1">
                Contact
              </h5>

              <a
                href="tel:+916352424442"
                className="text-gray-400 text-sm hover:text-blue-400"
              >
                +91 6352424442
              </a>

              <a
                href="mailto:connect@sahajink.com"
                className="text-gray-400 text-sm hover:text-blue-400"
              >
                connect@sahajink.com
              </a>

              <span className="text-gray-400 text-sm">Surat, Gujarat</span>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-white/10 py-6">
          <div className="max-w-[1200px] mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-2 text-gray-400 text-xs">
            <p>© 2026 Sahajink PVT LTD. All Rights Reserved.</p>
            <p className="text-center md:text-left">Premier Label Manufacturer in Surat, Gujarat. Serving India & International Clients.</p>
            <p>Beyond The Prints</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
